import request from "../../../../utils/api";

const url = "customers";

export const getCustomerAnalytics = body => request(`${url}/${body.id}/analytics`);
export const getCustomerTransactionsGraph = params => request(`${url}/${params.graph.id}/transactions_graph`, { params: params.graph.body });
